var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 50,
    viewBox: "0 0 45 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.692 5.08936H21.3691V7.41218H23.692V5.08936Z",
    fill: "#4AA851"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3691 7.41211H19.0463V9.73494H21.3691V7.41211Z",
    fill: "#4AA851"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0463 9.73499H16.7235V12.0578H19.0463V9.73499Z",
    fill: "#4AA851"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6607 42.4429H14.3379V44.7657H16.6607V42.4429Z",
    fill: "#4AA851"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6607 40.1201H14.3379V42.443H16.6607V40.1201Z",
    fill: "#4AA851"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6607 37.7345H14.3379V40.0573H16.6607V37.7345Z",
    fill: "#4AA851"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6607 35.4116H14.3379V37.7345H16.6607V35.4116Z",
    fill: "#4AA851"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6607 33.0887H14.3379V35.4116H16.6607V33.0887Z",
    fill: "#4AA851"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6607 30.766H14.3379V33.0888H16.6607V30.766Z",
    fill: "#4AA851"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6607 28.4431H14.3379V30.7659H16.6607V28.4431Z",
    fill: "#4AA851"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6607 26.0575H14.3379V28.3803H16.6607V26.0575Z",
    fill: "#4AA851"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6607 12.0577H14.3379V14.3806H16.6607V12.0577Z",
    fill: "#4AA851"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3379 14.4434H12.015V16.7662H14.3379V14.4434Z",
    fill: "#4AA851"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.015 16.7662H9.6922V19.0891H12.015V16.7662Z",
    fill: "#4AA851"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6922 19.0891H7.36937V21.4119H9.6922V19.0891Z",
    fill: "#4AA851"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44.723 21.4119H42.4001V23.7347H44.723V21.4119Z",
    fill: "#323232"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3374 19.0891H40.0145V21.4119H42.3374V19.0891Z",
    fill: "#323232"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6917 23.7347H35.3689H33.046V26.0576H35.3689H37.6917H40.0145H42.4001V23.7347H40.0145H37.6917Z",
    fill: "#323232"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0145 16.7662H37.6917V19.0891H40.0145V16.7662Z",
    fill: "#323232"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6917 14.4434H35.3689V16.7662H37.6917V14.4434Z",
    fill: "#323232"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3689 12.0577H33.046V14.3806H35.3689V12.0577Z",
    fill: "#323232"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7232 28.4431V30.7659V33.0888V35.4116V37.7344V40.12V42.4429V44.7657V47.0885H33.046V44.7657V42.4429V40.12V37.7344V35.4116V33.0888V30.7659V28.4431V26.0575H30.7232V28.4431Z",
    fill: "#323232"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M33.046 9.73499H30.7232V12.0578H33.046V9.73499Z",
    fill: "#323232"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6604 7.41211H28.3376V9.73494H30.6604V7.41211Z",
    fill: "#323232"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0148 47.0885H23.692H21.3691H19.0463H16.7235H14.3379V49.4113H16.7235H19.0463H21.3691H23.692H26.0148H28.3376H30.7232V47.0885H28.3376H26.0148Z",
    fill: "#323232"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3376 5.08936H26.0148V7.41218H28.3376V5.08936Z",
    fill: "#323232"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0148 2.76648H23.6919V5.08932H26.0148V2.76648Z",
    fill: "#323232"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M23.692 0.380859H21.3691V2.70369H23.692V0.380859Z",
    fill: "#323232"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3691 2.76648H19.0463V5.08932H21.3691V2.76648Z",
    fill: "#323232"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0463 5.08936H16.7235V7.41218H19.0463V5.08936Z",
    fill: "#323232"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6607 7.41211H14.3379V9.73494H16.6607V7.41211Z",
    fill: "#323232"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3379 42.4429V40.12V37.7344V35.4116V33.0888V30.7659V28.4431V26.0575H12.015V28.4431V30.7659V33.0888V35.4116V37.7344V40.12V42.4429V44.7657V47.0885H14.3379V44.7657V42.4429Z",
    fill: "#323232"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3379 9.73499H12.015V12.0578H14.3379V9.73499Z",
    fill: "#323232"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6922 23.7347H7.36937H5.04654H2.66093V26.0576H5.04654H7.36937H9.6922H12.015V23.7347H9.6922Z",
    fill: "#323232"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M12.015 12.0577H9.6922V14.3806H12.015V12.0577Z",
    fill: "#323232"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6922 14.4434H7.36937V16.7662H9.6922V14.4434Z",
    fill: "#323232"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36937 16.7662H5.04654V19.0891H7.36937V16.7662Z",
    fill: "#323232"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98376 19.0891H2.66093V21.4119H4.98376V19.0891Z",
    fill: "#323232"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66093 21.4119H0.338104V23.7347H2.66093V21.4119Z",
    fill: "#323232"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6917 21.4119H35.3689H33.046V23.7347H35.3689H37.6917H40.0145H42.4001V21.4119H40.0145H37.6917Z",
    fill: "#478443"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M33.046 23.7347H30.7232V26.0576H33.046V23.7347Z",
    fill: "#478443"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3376 28.4431V30.7659V33.0888V35.4116V37.7344V40.12V42.4429V44.7657H26.0148H23.692H21.3691H19.0463H16.7235V47.0885H19.0463H21.3691H23.692H26.0148H28.3376H30.7232V44.7657V42.4429V40.12V37.7344V35.4116V33.0888V30.7659V28.4431V26.0575H28.3376V28.4431Z",
    fill: "#478443"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M33.046 14.4434H30.7232V12.0578H28.3376V9.73494H26.0148V7.41211H23.692H21.3691V9.73494V12.0578H19.0463V14.4434H16.7235V16.7662H14.3379V19.089H12.015H9.6922V21.4119H12.015V23.7347H14.3379V26.0575H16.7235V28.4431V30.766V33.0888V35.4116V37.7344V40.12V42.4429H19.0463H21.3691H23.692H26.0148V40.12V37.7344V35.4116V33.0888V30.766V28.4431V26.0575H28.3376V23.7347V21.4119H30.7232H33.046V19.089H35.3689V16.7662H33.046V14.4434Z",
    fill: "#4AA851"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6917 16.7662H35.3689V19.0891H33.046V21.4119H35.3689H37.6917H40.0145V19.0891H37.6917V16.7662Z",
    fill: "#4AA851"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3689 14.4434H33.046V16.7662H35.3689V14.4434Z",
    fill: "#4AA851"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M33.046 12.0577H30.7232V14.3806H33.046V12.0577Z",
    fill: "#4AA851"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3376 21.4119V23.7347V26.0575H30.7232V23.7347H33.046V21.4119H30.7232H28.3376Z",
    fill: "#4AA851"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6604 9.73499H28.3376V12.0578H30.6604V9.73499Z",
    fill: "#4AA851"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0148 28.4431V30.7659V33.0888V35.4116V37.7344V40.12V42.4429H23.692H21.3691H19.0463H16.7235V44.7657H19.0463H21.3691H23.692H26.0148H28.3376V42.4429V40.12V37.7344V35.4116V33.0888V30.7659V28.4431V26.0575H26.0148V28.4431Z",
    fill: "#4AA851"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3376 7.41211H26.0148V9.73494H28.3376V7.41211Z",
    fill: "#4AA851"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0148 5.08936H23.6919V7.41218H26.0148V5.08936Z",
    fill: "#4AA851"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6607 44.7657H14.3379V47.0886H16.6607V44.7657Z",
    fill: "#4AA851"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3379 23.7347H12.015V26.0576H14.3379V23.7347Z",
    fill: "#4AA851"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6922 21.4119H7.36937H5.04654V23.7347H7.36937H9.6922H12.015V21.4119H9.6922Z",
    fill: "#4AA851"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M23.692 2.76648H21.3691V5.08932H23.692V2.76648Z",
    fill: "#80E977"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3691 5.08936H19.0463V7.41218H21.3691V5.08936Z",
    fill: "#80E977"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0463 7.41211H16.7235V9.73494H19.0463V7.41211Z",
    fill: "#80E977"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6607 9.73499H14.3379V12.0578H16.6607V9.73499Z",
    fill: "#80E977"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3379 12.0577H12.015V14.3806H14.3379V12.0577Z",
    fill: "#80E977"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M12.015 14.4434H9.6922V16.7662H12.015V14.4434Z",
    fill: "#80E977"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6922 16.7662H7.36937V19.0891H9.6922V16.7662Z",
    fill: "#80E977"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36937 19.0891H5.04654V21.4119H7.36937V19.0891Z",
    fill: "#80E977"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98376 21.4119H2.66093V23.7347H4.98376V21.4119Z",
    fill: "#80E977"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3691 9.73499H19.0463V12.0578H21.3691V9.73499Z",
    fill: "#6BD063"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0463 12.0577H16.7235V14.3806H19.0463V12.0577Z",
    fill: "#6BD063"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6607 14.4434H14.3379V16.7662H16.6607V14.4434Z",
    fill: "#6BD063"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3379 16.7662H12.015V19.0891H14.3379V16.7662Z",
    fill: "#6BD063"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.4d7aeb986c48b97a46b43d4ec1fa182c.svg";
export { ForwardRef as ReactComponent };